import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadComponent } from './upload/upload.component';
import { CustomMappingComponent } from './custom-mapping/custom-mapping.component';
import { ShipmentUploadStatusComponent } from './shipment-upload-status/shipment-upload-status.component';
import { ShipmentUploadValidationShowComponent } from './shipment-upload-status/shipment-upload-validation-show/shipment-upload-validation-show.component';
import { CustomLineitemMappingComponent } from './custom-lineitem-mapping/custom-lineitem-mapping.component';
import { BbxMappingComponent } from './bbx-mapping/bbx-mapping.component';
import { InvoiceSpecificationListComponent } from './specifications/components/invoice-specification-list/invoice-specification-list.component';
import { ShipmentSpecificationListComponent } from './specifications/components/shipment-specification-list/shipment-specification-list.component';
import { AddEditInvoiceSpecificationComponent } from './specifications/components/invoice-specification-list/add-edit-invoice-specification/add-edit-invoice-specification.component';
import { SpecificationUploadComponent } from './specifications/components/common/specification-upload/specification-upload.component';
import { AddEditShipmentSpecificationComponent } from './specifications/components/shipment-specification-list/add-edit-shipment-specification/add-edit-shipment-specification.component';
import { ShipmentSpecificationTableComponent } from './specifications/components/shipment-specification-list/shipment-specification-table/shipment-specification-table.component';
import { InvoiceSpecificationTableComponent } from './specifications/components/invoice-specification-list/invoice-specification-table/invoice-specification-table.component';

@NgModule({
  declarations: [
    UploadComponent,
    CustomMappingComponent,
    ShipmentUploadStatusComponent,
    ShipmentUploadValidationShowComponent,
    CustomLineitemMappingComponent,
    BbxMappingComponent,

    ShipmentSpecificationListComponent,
    AddEditShipmentSpecificationComponent,
    ShipmentSpecificationTableComponent,

    InvoiceSpecificationListComponent,
    AddEditInvoiceSpecificationComponent,
    InvoiceSpecificationTableComponent,

    SpecificationUploadComponent,
  ],
  imports: [CommonModule, SharedModule, FormsModule, ReactiveFormsModule],
})
export class MappingModule {}
